import { postJSON } from 'common/services/api'
import {
  CHECK_FUNDING_TYPE_QUERY_KEY,
  CHECK_FUNDING_TYPE_URL,
} from './queryConstants'
import { useMutation } from 'react-query'

type FundingTypeCheck = {
  fundingTypeId: string
  residentId: string
}

type UseCheckFundingTypeReturn = {
  checkFundingTypeUsedInRota: (values: FundingTypeCheck) => Promise<any>
  isLoading: boolean
}

const useCheckFundingType = (): UseCheckFundingTypeReturn => {
  const createFunction = async (values: FundingTypeCheck) => {
    return postJSON({
      url: CHECK_FUNDING_TYPE_URL,
      method: 'POST',
      json: values,
      isRota: true,
    })
  }

  const { mutateAsync: createMutation, isLoading } = useMutation<
    any,
    unknown,
    any,
    unknown
  >([CHECK_FUNDING_TYPE_QUERY_KEY], createFunction)

  const checkFundingTypeUsedInRota = async (values: any) => {
    try {
      const result = await createMutation(values)
      return result
    } catch (err) {
      return err
    }
  }

  return {
    checkFundingTypeUsedInRota,
    isLoading,
  }
}

export default useCheckFundingType
